var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.05,
    height: 62.05,
    viewBox: "0 0 62.05 62.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.43,23.46C29.55,4.05,31.64,5.19,31.03,5.19c-.56,0,.12-.32-11.63,6.84V2.59c1.71,0,1.71-2.59,0-2.59h-10.34c-1.71,0-1.71,2.59,0,2.59v15.74L.62,23.46c-.57.35-.78,1.08-.48,1.68,3.76,7.53,2.19,7.07,8.9,2.92v30.11c0,2.14,1.74,3.88,3.88,3.88h36.2c2.14,0,3.88-1.74,3.88-3.88v-30.13c6.75,4.18,5.17,4.63,8.93-2.9.3-.6.09-1.33-.48-1.68ZM11.64,2.59h5.17v11.02l-5.17,3.15V2.59Zm38.77,55.59c0,.71-.58,1.29-1.29,1.29H12.91c-.71,0-1.29-.58-1.29-1.29v-31.71l19.41-12.02,19.37,11.99v31.73Zm7.25-30.29C29.89,10.7,31.65,11.66,31.03,11.66c-.59,0,1.32-1.07-26.62,16.23l-1.42-2.84L31.03,7.98l28.05,17.07-1.42,2.84Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.03,27.15c-7.13,0-12.93,5.8-12.93,12.93s5.8,12.93,12.93,12.93,12.93-5.8,12.93-12.93-5.8-12.93-12.93-12.93Zm0,23.27c-5.7,0-10.34-4.64-10.34-10.34s4.64-10.34,10.34-10.34,10.34,4.64,10.34,10.34-4.64,10.34-10.34,10.34Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.03,38.78c-2.28,0-5.13,1.87-3.65,3.34.5.5,1.32.5,1.83,0,.98-.98,2.67-.98,3.65,0,.5.5,1.32.51,1.83,0,1.48-1.48-1.38-3.34-3.65-3.34Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.71,36.64c-1.21,1.21.62,3.04,1.83,1.83,3.03-3.03,7.94-3.03,10.97,0,1.21,1.21,3.04-.62,1.83-1.83-4.04-4.04-10.58-4.04-14.63,0Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.03,43.95c-1.71,0-1.71,2.59,0,2.59s1.71-2.59,0-2.59Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.13f3dc87e1afeb637d7d7d54f526933c.svg";
export { ForwardRef as ReactComponent };